import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationScoreInadimplenciaEvolucao() {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-score-inadimplencia-evolucao'],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_INADIMPLENCIA_EVOLUCAO),
  });
}

export { useConsolidationScoreInadimplenciaEvolucao };
